export const config = {
  publicUrl: import.meta.env.VITE_PUBLIC_URL as string,
  supabase: {
    url: import.meta.env.VITE_SUPABASE_URL as string,
    anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY as string,
  },
  betterAuth: {
    url: import.meta.env.VITE_BETTER_AUTH_URL as string | undefined,
    basePath: import.meta.env.VITE_BETTER_AUTH_BASE_PATH as string | undefined,
  },
  debug: import.meta.env.VITE_DEBUG === 'true',
} as const
